"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosResult = exports.isAxiosError = void 0;
const Result_1 = require("./Result");
function isAxiosError(e) {
    return e.isAxiosError;
}
exports.isAxiosError = isAxiosError;
/**
 * Converts the response from Axios to a "Ok" result or "HttpBad" result.
 */
class AxiosResult {
    /**
     * Takes the response from the given callback, and converts it to a result.
     * @param callback A call to Axios returning a response
     */
    static async from(callback) {
        var _a, _b;
        try {
            const { data } = await callback();
            return Result_1.Ok(data);
        }
        catch (e) {
            const { request, response } = e;
            // We got the server response
            if (response) {
                // Client error
                if (response.status >= 400 && response.status < 500)
                    return Result_1.Bad((_a = response.data) === null || _a === void 0 ? void 0 : _a.reason, (_b = response.data) === null || _b === void 0 ? void 0 : _b.value);
                // Server error
                throw e;
            }
            // We never got the server response, possibly a network error
            else if (request)
                throw e;
            // Configuration problem
            throw e;
        }
    }
}
exports.AxiosResult = AxiosResult;
//# sourceMappingURL=AxiosResult.js.map